export default interface TransactionInvoiceInfo {
    id: number;
    prefix: string;
    partnerName: string;
    partnerRelation: string;
    status: string;
    payMod: string;
    currency: string;
    invCurrency: string;

    netto: number;
    total: number;
    vat: number;
    currNetto: number;
    currTotal: number;
    currVat: number;
    exchangeRate: number;

    rateDate: Date | string;
    invDate: Date | string;
    shipDate: Date | string;
    payTerm: Date | string;

    storno: boolean;
    dPayTerm: boolean;
    dPayMod: boolean;
    dPayModIncl: boolean;
    accStatus: string;
    accGroup: string;
    remark: string;
    remark2: string;
}
export const TransactionInvoiceInfoProps: TransactionInvoiceInfo = {
    id: 1,
    prefix: "",
    partnerName: "",
    partnerRelation: "",
    status: "",
    payMod: "",
    currency: "",
    invCurrency: "",
    netto: 1,
    total: 1,
    vat: 1,
    currNetto: 1,
    currTotal: 1,
    currVat: 1,
    exchangeRate: 1,
    rateDate: "1990-01-01",
    invDate: "1990-01-01",
    shipDate: "1990-01-01",
    payTerm: "1990-01-01",
    storno: false,
    dPayMod: false,
    dPayModIncl: false,
    dPayTerm: false,
    accStatus: "",
    accGroup: "",
    remark: "",
    remark2: "",
};